import React from "react";
import styled from "styled-components";
import DidYouKnowInline from "./DidYouKnowInline";

export default function DidYouKnowFragmented() {
  return (
    <Wrapper aria-label="Did you know (fragmented systems)">
      <div className="lightBg" style={{ padding: "0 0 20px 0" }}>
        <div className="container">
          <DidYouKnowInline
            body="Most law firms still rely on fragmented systems for cases, documents, and deadlines."
            imageSrc="/didyouknow.png"
            imageAlt="Illustration of fragmented systems and legal work"
            reverse
          />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;